import { Component, OnInit, Input, EventEmitter, Output, ViewEncapsulation, SimpleChanges, OnChanges } from "@angular/core";
import * as _ from 'lodash';
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import moment from "moment";
import { FormsErrorsService } from '../../../services/forms-error.service';

@Component({
   selector: "mapfre-auditlib-item",
   templateUrl: "./item.component.html",
   styleUrls: ["./item.component.scss"],
   encapsulation: ViewEncapsulation.None
})
export class ItemComponent implements OnChanges {
   _data;
   _columns;

   checked: boolean = true;

   @Input()
   get data() {
      return this._data;
   }
   set data(value) {
      this._data = value;
   }

   @Input()
   get columns() {
      return this._columns;
   }
   set columns(value) {
      this._columns = value;
   }

   _selectData;
   @Input()
   get selectData() {
      return this._selectData;
   }
   set selectData(value) {
      this._selectData = value;
      setTimeout(() => this.selectDataChange.emit(this._selectData));
   }

   form: UntypedFormGroup;
   @Input() edit;
   @Input() actions;
   @Input() defaultActions;

   @Input() nuuma;

   @Input() selectTable;
   @Input() typeSelect;

   @Output() selectDataChange = new EventEmitter();
   @Output() selectChange = new EventEmitter();
   @Output() actionClicked = new EventEmitter();
   @Output() updated = new EventEmitter();
   @Output() created = new EventEmitter();
   @Output() deleted = new EventEmitter();

   @Input() collapsed = false;
   constructor(private formsErrorService: FormsErrorsService) { }

   ngOnChanges(change: SimpleChanges) {
      /*if(change.selectData){
      this.checkItem();
    }*/
      this.createFormGroup();
      this.checkItem();
   }

   checkItem() {
      if (this.selectTable) {
         this.checked = _.some(this._selectData, item => {
            return _.isEqual(item, this.data);
         });
      }
   }

   createFormGroup() {
      this.form = new UntypedFormGroup({});
      this._columns.forEach(element => {
         let initValue = this._data[element.field];
         if (element.type === "date") {
            initValue =
               this._data[element.field] && _.get(element, "options.selectionMode") === "single"
                  ? moment(this._data[element.field], 'YYYY-MM-DD').toDate()
                  : this._data[element.field];

            this.form.addControl(element.field, new UntypedFormControl(initValue, element.validators));
         } else if (element.type === "select" && element.options.selectionMode === "simple") {
            initValue = this._data[element.field] ? [this._data[element.field]] : null;

            this.form.addControl(element.field, new UntypedFormControl(initValue, element.validators));
         } else {
            this.form.addControl(element.field, new UntypedFormControl(initValue, element.validators));
         }
      });
   }

   toggleEdit() {
      this.edit = !this.edit;
      this.edit ? this.actionClicked.emit("edit") : this.actionClicked.emit("stopEdit")
      //Si se ha cancelado la edición se resetea el form
      if (!this.edit) {
         this.createFormGroup();
      }
   }
   onCancelled() {
      if (this.data.hasOwnProperty("edit")) {
         this.actionClicked.emit("cancelled");
      }
      this.toggleEdit();
   }

   onSave() {
      if (this.form.valid) {
         let formValue = this.form.value;
         if (this.data.hasOwnProperty("edit")) {
            this.created.emit(formValue);
         } else {
            this.updated.emit(formValue);
         }
         this.toggleEdit();
      } else {
         this.form.markAllAsTouched();
         this.formsErrorService.notifyVisible(true);
      }
   }

   onActionClicked(action) {
      this.actionClicked.emit(action.key);
   }

   onDelete() {
      this.deleted.emit(this._data);
   }

   get(object, field) {
      return field ? _.get(object, field) : object;
   }

   selectSimpleClick(event) {
      if (event) {
         this.selectData = [];
         this.selectData.push(this.data);
      } else {
         _.remove(this.selectData, this.data);
      }
      //this.selectDataChange.emit(this.selectData)
   }

   onSelectChange(event) {
      this.selectChange.emit(event);
   }

   getFlag(object, field) {
      return _.get(object, field) ? "./assets/flags/" + _.get(object, field).toLowerCase() + ".png" : "";
   }

   selectMultipleClick(event) {
      if (event) {
         this.selectData.push(this.data);
      } else {
         _.remove(this.selectData, this.data);
      }
      this.selectDataChange.emit(this.selectData);
   }

   getName(name) {
      if (name) {
         return name
      } else {
         return this.nuuma
      }
   }

   getDate(date) {
      if (date) {
         return date
      } else {
         return new Date();
      }
   }
   showList(dataList, field) {
      let temp: string = ``;
      for (let data of dataList) {
         temp += `<span style="color:white;">${this.get(data, field)}</span><br>`;
      }
      return temp;

   }
}
